/* No canvas, polling, network calls or animation loop. The seasonal class is authoritative. */
(function () {
  'use strict';
  if (window.__ttgHalloween2026) return;
  window.__ttgHalloween2026 = true;
  var root = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var entries = [], paused = false;
  try { paused = sessionStorage.getItem('ttg-halloween-paused') === '1'; } catch (_) {}
  var language = (root.lang || 'it').slice(0, 2);
  var labels = language === 'en' ? ['Pause Halloween animations', 'Resume Halloween animations'] :
    language === 'de' ? ['Halloween-Animationen pausieren', 'Halloween-Animationen fortsetzen'] :
    ['Pausa animazioni Halloween', 'Riprendi animazioni Halloween'];
  var ghost = '<svg viewBox="0 0 40 50" focusable="false" aria-hidden="true"><path d="M5 44V21C5 1 35 1 35 21v23l-7-5-8 6-8-6z" fill="#f4ede4" stroke="#e8bf95" stroke-width="1.2"/><ellipse cx="15" cy="22" rx="2" ry="3" fill="#3d3147"/><ellipse cx="25" cy="22" rx="2" ry="3" fill="#3d3147"/><path d="M17 30q3 3 6 0" fill="none" stroke="#88728e" stroke-width="1.5" stroke-linecap="round"/></svg>';
  var bat = '<svg viewBox="0 0 48 30" focusable="false" aria-hidden="true"><g fill="#392d4b" stroke="#e8bf95" stroke-width=".65" stroke-linejoin="round"><path class="ttg-halloween__wing" d="M24 14Q12 3 1 6q5 3 4 10 6-4 10 3 4-4 9 0z"/><path class="ttg-halloween__wing ttg-halloween__wing--right" d="M24 14Q36 3 47 6q-5 3-4 10-6-4-10 3-4-4-9 0z"/><path d="m20 10 1-6 4 5 3-4v9q4 12-4 13-8-1-4-13z"/></g></svg>';
  function update() {
    entries.forEach(function (e) {
      e.layer.dataset.paused = String(paused || document.hidden || !e.visible);
      e.button.setAttribute('aria-label', labels[paused ? 1 : 0]);
      e.button.title = labels[paused ? 1 : 0];
      e.button.setAttribute('aria-pressed', String(paused));
      e.button.textContent = paused ? '\u25b6' : '\u2161';
    });
  }
  function destroy() {
    entries.forEach(function (e) {
      if (e.intersection) e.intersection.disconnect();
      if (e.resize) e.resize.disconnect();
      e.layer.remove(); e.button.remove();
    });
    entries = [];
  }
  function reconcile() {
    if (!root.classList.contains('ttg-season-halloween') || reduced.matches) { destroy(); return; }
    if (entries.length) { update(); return; }
    document.querySelectorAll('.ttg-season-band').forEach(function (scene) {
      var layer = document.createElement('span');
      layer.className = 'ttg-halloween'; layer.setAttribute('aria-hidden', 'true');
      layer.innerHTML = '<span class="ttg-halloween__ghost">' + ghost + '</span>' +
        '<span class="ttg-halloween__ghost ttg-halloween__ghost--far">' + ghost + '</span>' +
        '<span class="ttg-halloween__bat">' + bat + '</span>' +
        '<span class="ttg-halloween__bat ttg-halloween__bat--far">' + bat + '</span>';
      scene.appendChild(layer);
      // A sibling of the link: never put a button inside a clickable banner.
      var button = document.createElement('button'); button.type = 'button';
      button.className = 'ttg-halloween-toggle'; scene.parentNode.appendChild(button);
      var e = { layer:layer, button:button, visible:true };
      entries.push(e);
      button.addEventListener('click', function () {
        paused = !paused;
        try { sessionStorage.setItem('ttg-halloween-paused', paused ? '1' : '0'); } catch (_) {}
        update();
      });
      function size() { layer.style.setProperty('--ttg-halloween-travel', (scene.clientWidth + 100) + 'px'); }
      size();
      if (window.ResizeObserver) { e.resize = new ResizeObserver(size); e.resize.observe(scene); }
      if (window.IntersectionObserver) {
        e.intersection = new IntersectionObserver(function (items) { e.visible = items[0].isIntersecting; update(); });
        e.intersection.observe(scene);
      }
    });
    update();
  }
  document.addEventListener('visibilitychange', update);
  document.addEventListener('shopify:section:load', function () { destroy(); reconcile(); });
  if (reduced.addEventListener) reduced.addEventListener('change', reconcile);
  else reduced.addListener(reconcile);
  new MutationObserver(reconcile).observe(root, { attributes:true, attributeFilter:['class'] });
  reconcile();
}());
